import React from "react";
import Swiper from "swiper";

let $ = window.$;

class Related extends React.Component {
  componentDidUpdate() {
    new Swiper(".matchingPdt_wrap .swiper-container", {
      slidesPerView: 4,
      spaceBetween: 0,
      observer: true,
      observeParents: true,
      navigation: {
        prevEl: ".matchingPdt_wrap .button-prev",
        nextEl: ".matchingPdt_wrap .button-next"
      }
    });
    $(document).on("mouseenter", ".matchingPdt_wrap .pdtImg_link", function() {
      $(".matchingPdt_wrap .pdtName").text($(this).attr("data-pdtName"));
      $(".matchingPdt_wrap .pdtHkPrice").text($(this).attr("data-hkprice"));
      $(".matchingPdt_wrap .pdtEurPrice").text($(this).attr("data-eurprice"));
    });
  }
  render() {
    const { matchingPdt } = this.props;
    return (
      <div className="matchingPdt_wrap">
        <div className="clearfix">
          <div className="float-left">
            <p className="subtitle">
              <span>
                配搭頸鏈: <span className="pdtName" />
              </span>
            </p>
            <div className="sellingPrice_wrap">
              <div className="price">
                HK$<span className="pdtHkPrice">-</span>
              </div>
              <div className="priceInEur">
                (EUR€<span className="pdtEurPrice">-</span>)
              </div>
            </div>
          </div>
          <div className="float-right">
            <a href="/" className="content-link seeMore">
              查看更多
            </a>
          </div>
        </div>

        <div className="swiper_wrap">
          <div className="swiper-container">
            <div className="swiper-wrapper">
              {matchingPdt.map((item, index) => (
                <div key={item.name + index} className="swiper-slide">
                  <a
                    className="pdtImg_link"
                    href="/"
                    data-pdtname={item.name}
                    data-hkprice={item.hkprice}
                    data-eurprice={item.eurprice}
                    style={{
                      backgroundImage: `url(${item.img})`
                    }}
                  >
                    {}
                  </a>
                </div>
              ))}
            </div>
          </div>
          <div className="swiperArrows_wrap">
            <button className="button-prev" />
            <button className="button-next" />
          </div>
        </div>
      </div>
    );
  }
}

export default Related;
